// import components
import { Box, Button, Typography } from '@mui/material';
import { Text } from './TravelDetailStyles';

// import translations
import { t } from 'i18next';

// import types
import {
  ExpenseClaimRouteResponse,
  TravelMovementResponse
} from 'generated/index';
import { Icon } from '@sdb/planning-ui';

export type TravelDetailDialogRoutesHeaderProps = {
  routes: TravelMovementResponse[] | ExpenseClaimRouteResponse[];
  isTravelMovements?: boolean;
  isManual?: boolean;
  isEditMode: boolean;
  toggleEditMode: () => void;
  handleSave: () => void;
  isLoading: boolean;
  isRealised: boolean;
  isCredited?: boolean;
  isDistanceTouched?: boolean;
};

const TravelDetailDialogRoutesHeader = ({
  routes,
  isTravelMovements,
  isManual,
  isEditMode,
  toggleEditMode,
  handleSave,
  isLoading,
  isRealised,
  isCredited,
  isDistanceTouched
}: TravelDetailDialogRoutesHeaderProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        py: 1
      }}
    >
      <Typography variant="h6">
        {t('travelExpenseClaims.routes')} ({routes.length})
      </Typography>

      {isTravelMovements &&
        !isManual &&
        !isRealised &&
        !isCredited &&
        (isEditMode ? (
          <Box
            sx={{
              display: 'flex',
              gap: '2px',
              alignItems: 'center'
            }}
          >
            <Button
              variant="contained"
              color="secondary"
              size="small"
              onClick={toggleEditMode}
              sx={{
                display: 'flex',
                gap: '6px',
                alignItems: 'center'
              }}
            >
              <Text>{t('cancel')}</Text>
            </Button>
            <Button
              variant="contained"
              color="primary"
              size="small"
              onClick={() => handleSave()}
              disabled={isLoading || !isDistanceTouched}
              sx={{
                display: 'flex',
                gap: '6px',
                alignItems: 'center'
              }}
            >
              <Text>{t('save')}</Text>
            </Button>
          </Box>
        ) : (
          <Button
            variant="text"
            size="small"
            onClick={toggleEditMode}
            sx={{
              display: 'flex',
              gap: '6px',
              alignItems: 'center'
            }}
          >
            <Icon type="pen-to-square" fontSize="small" />
            <Text>{t('travelMovements.editDistance')}</Text>
          </Button>
        ))}
    </Box>
  );
};

export default TravelDetailDialogRoutesHeader;
